import {createSelector} from 'reselect';
import props from '../props';

export default createSelector(
    props.popups.loaded,
    props.popups.popups,
    (loaded, popups) => {
        return {
            loaded,
            popups
        }
    }
)